var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid full-width-page-wrapper ifac-officials"},[_c('div',[_c('h3',{staticClass:"font-weight-bold page-title"},[_vm._v("Awardees")]),_c('div',{staticClass:"mb-4 border-0"},[(_vm.categories)?_c('awards',{attrs:{"categories":_vm.categories}}):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }